import { render, staticRenderFns } from "./InstantPopupDialog.vue?vue&type=template&id=aed9abc6&"
import script from "./InstantPopupDialog.vue?vue&type=script&lang=js&"
export * from "./InstantPopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./InstantPopupDialog.vue?vue&type=style&index=0&id=aed9abc6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCarousel,VCarouselItem,VCol,VDialog,VIcon,VRow,VSheet})
